var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDowloadinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.406,
    width: 26,
    height: 26,
    rx: 5,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.496 21.345l-3.405-3.366c-.782-.785.392-1.964 1.175-1.178l1.462 1.467c.245.246.442.164.442-.181v-6.113c0-.46.371-.833.83-.833.459 0 .83.373.83.833v6.113c0 .343.198.426.442.181l1.462-1.467c.783-.786 1.957.393 1.175 1.178l-3.377 3.364a.737.737 0 01-1.036.002zm3.212-5.83a.833.833 0 010-1.666h.21c.229 0 .415-.187.415-.417V7.6a.417.417 0 00-.416-.417h-5.834a.417.417 0 00-.416.417v5.833c0 .23.186.417.416.417h.209a.833.833 0 010 1.667h-.21A2.083 2.083 0 018 13.432V7.6c0-1.15.933-2.083 2.083-2.083h5.834c1.15 0 2.083.932 2.083 2.083v5.833c0 1.15-.932 2.084-2.083 2.084h-.209z",
    fill: "#F6610D"
  })));
}

export default SvgDowloadinline;